<div [formGroup]="parentFormGroup!">
  @for (dataset of config; track dataset; let i = $index) {
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
      <mat-icon>{{ dataset.icon }}</mat-icon>
      <p class="no-pad m-b-1 m-t-2">{{ dataset.label | translate }}</p>
    </div>
    <recrewt-chip-editor [formControlName]="dataset.groupName"
      [predefined]="dataset.data"
     />
  }
</div>
